export const HOURS_ON_GET_REQUESTED = 'HOURS_ON_GET_REQUESTED';
export const HOURS_ON_GET_SUCCEEDED = 'HOURS_ON_GET_SUCCEEDED';
export const HOURS_ON_GET_FAILED = 'HOURS_ON_GET_FAILED';

export const HOURS_ON_CREATE_REQUESTED = 'HOURS_ON_CREATE_REQUESTED';
export const HOURS_ON_CREATE_SUCCEEDED = 'HOURS_ON_CREATE_SUCCEEDED';
export const HOURS_ON_CREATE_FAILED = 'HOURS_ON_CREATE_FAILED';

export const HOURS_ON_EDIT_REQUESTED = 'HOURS_ON_EDIT_REQUESTED';
export const HOURS_ON_EDIT_SUCCEEDED = 'HOURS_ON_EDIT_SUCCEEDED';
export const HOURS_ON_EDIT_FAILED = 'HOURS_ON_EDIT_FAILED';

export const HOURS_ON_DELETE_REQUESTED = 'HOURS_ON_DELETE_REQUESTED';
export const HOURS_ON_DELETE_SUCCEEDED = 'HOURS_ON_DELETE_SUCCEEDED';
export const HOURS_ON_DELETE_FAILED = 'HOURS_ON_DELETE_FAILED';
